import { SIGN_UP_FIELDS } from 'components/generics/flows/LoginSignUpFlow/SignUpFlow/components/SignUp/utils';
import { ChangeEvent } from 'react';

export type FieldObjectType = {
  value: any;
  isValid: boolean;
  errorMessage: string;
};

export type SignUpContextType = {
  phoneNumber: string;
  email: string;
  fullName: string;
  dateOfBirth: string;
  dateOfBirthErrorMessage: string;
  fieldChangeHandler: (
    field: SIGN_UP_FIELDS
  ) => (e: ChangeEvent<HTMLInputElement> | string) => void;
  isFormValid: boolean;
  checkFormValid: (filterFields: SIGN_UP_FIELDS[]) => boolean;
};

export const INITIAL_SIGNUP_DATA: { [key in SIGN_UP_FIELDS]: FieldObjectType } =
  {
    [SIGN_UP_FIELDS.EMAIL]: {
      value: '',
      isValid: false,
      errorMessage: '',
    },
    [SIGN_UP_FIELDS.PHONE_NUMBER]: {
      value: 0,
      isValid: false,
      errorMessage: '',
    },
    [SIGN_UP_FIELDS.FULL_NAME]: {
      value: '',
      isValid: false,
      errorMessage: '',
    },
    [SIGN_UP_FIELDS.DATE_OF_BIRTH]: {
      value: '',
      isValid: false,
      errorMessage: '',
    },
  };
